import { render } from "./App.vue?vue&type=template&id=68ee0c84&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=68ee0c84&lang=scss"

import exportComponent from "D:\\source\\0000_official_website\\official_website_vue_vsc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__